module.exports = __webpack_public_path__ + "943a425a4379ddaf6ab0aff2ebd8001b.png";